import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
    const handleCookieSettings = () => {
        localStorage.removeItem('cookie-consent');
        window.location.reload(); // Re-show cookie banner
    };

    return (
        <footer className="border-t border-border-color py-4 text-center text-sm text-text-secondary bg-primary-bg">
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
                <Link to="/privacy" className="hover:text-accent transition-colors">
                    Privacy Policy
                </Link>
                <Link to="/terms" className="hover:text-accent transition-colors">
                    Terms of Service
                </Link>
                <button
                    onClick={handleCookieSettings}
                    className="hover:text-accent transition-colors underline cursor-pointer"
                >
                    Cookie Settings
                </button>
            </div>
        </footer>
    );
};

export default Footer;
